import { render, staticRenderFns } from "./MessageFiles.vue?vue&type=template&id=2db9c755&scoped=true&"
import script from "./MessageFiles.vue?vue&type=script&lang=js&"
export * from "./MessageFiles.vue?vue&type=script&lang=js&"
import style0 from "./MessageFiles.vue?vue&type=style&index=0&id=2db9c755&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9c755",
  null
  
)

export default component.exports